<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="7">
          <v-card outlined class="pa-4">
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="8" class="text-h6">Podaci o svjedodžbama</v-col>
            </v-row>
            <v-row
              v-for="(val, key, index) in departmentInfo"
              :key="index"
            >
              <v-col class="text-right font-weight-light">{{ key }}:</v-col>
              <v-col cols="8">{{ val ? val : '-' }}</v-col>
            </v-row>
          </v-card>
          <v-card outlined class="my-4 pa-4" v-if="department.graduation_type===1">
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="8" class="text-h6">Podaci o maturi</v-col>
            </v-row>
            <v-row
                v-for="(val, key, index) in departmentInfo1"
                :key="index"
            >
              <v-col class="text-right font-weight-light">{{ key }}:</v-col>
              <v-col cols="8">{{ val ? val : '-' }}</v-col>
            </v-row>
          </v-card>
          <v-card outlined class="my-4 pa-4" v-if="department.graduation_type===2">
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="8" class="text-h6">Podaci o završnom radu</v-col>
            </v-row>
            <v-row
                v-for="(val, key, index) in departmentInfo2"
                :key="index"
            >
              <v-col class="text-right font-weight-light">{{ key }}:</v-col>
              <v-col cols="8">{{ val ? val : '-' }}</v-col>
            </v-row>
          </v-card>
          <v-card outlined class="my-4 pa-4">
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="8" class="text-h6">Podaci o svjedodžbi prijevodnici</v-col>
            </v-row>
            <v-row
                v-for="(val, key, index) in departmentInfo4"
                :key="index"
            >
              <v-col class="text-right font-weight-light">{{ key }}:</v-col>
              <v-col cols="8">{{ val ? val : '-' }}</v-col>
            </v-row>
            <v-row
                v-for="(val, key, index) in departmentInfo5"
                :key="index"
            >
              <v-col class="text-right font-weight-light">{{ key }}:</v-col>
              <v-col cols="8">{{ val ? val : '-' }}</v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" md="3">
          <v-btn
            block
            depressed
            class="text-none"
            color="primary"
            height="44"
            @click="openEdit"
            v-if="$checkPermission('button_edit_diplomas_in_department')"
          >
            Uredi podatke
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      v-model="dialog"
      width="800"
      @click:outside="closeEdit"
    >
      <v-card>
        <v-toolbar color="primary" dark class="elevation-0">
            <v-toolbar-title>Uredite podatke</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn @click.native="closeEdit" dark icon>
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-container class="pt-6">
          <v-row>
            <v-col>
              <v-expansion-panels popout>
                <v-expansion-panel
                >
                  <v-expansion-panel-header>1. polugodište</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ValidationProvider
                        :name="item.name"
                        :rules="item.rules"
                        mode="eager"
                        ref="provider"
                        v-bind:key="item.name"
                        v-for="item in items1"
                    >
                      <div slot-scope="{ errors }">
                        <v-row no-gutters>

                          <!--Label for the form-->
                          <v-col cols="12" md="3" style="height: 44px" class="d-flex justify-end">
                            <div class="d-flex align-center justify-end text-right mb-2">
                                  <span class="font-weight-bold text--primary"
                                        :style="{color: errors.length > 0 ? 'rgb(236 29 36) !important' : '', opacity: 0.8, marginRight: '8px'}">{{ item.title }}:</span>
                            </div>
                          </v-col>
                          <!-- Text field -->
                          <v-col cols="12" md="9">

                            <v-text-field
                                dense
                                :name="item.name"
                                outlined
                                :type="item.type"
                                :placeholder="item.rules && item.rules.includes('required') ? 'Obavezno...' : ''"
                                :prepend-icon="item.icon"
                                v-if="item.tag === 'input'"
                                v-model="form[item.name]">
                            </v-text-field>

                            <v-autocomplete
                                outlined
                                dense
                                :placeholder="item.rules ? 'Obavezno..' : ''"
                                :items="item.source"
                                :name="item.name"
                                :prepend-icon="item.icon"
                                :item-text="item.text"
                                :item-value="item.value"
                                v-if="item.tag === 'select'&& item.name!='are_numerical_grades_semester'"
                                v-model="form[item.name]">
                            </v-autocomplete>
                            <v-autocomplete
                                outlined
                                dense
                                :placeholder="item.rules ? 'Obavezno..' : ''"
                                :items="item.source"
                                :name="item.name"
                                :prepend-icon="item.icon"
                                :item-text="item.text"
                                :item-value="item.value"
                                v-if="item.tag === 'select' && item.name=='are_numerical_grades_semester'"
                                @change="updateDepartment(true, true, false)"
                                v-model="form[item.name]">
                            </v-autocomplete>

                            <!-- Date picker -->
                            <v-menu
                                v-model="item.model"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                                v-if="item.tag === 'date'"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="form[item.name]"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="form[item.name]" >

                              </v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </div>
                    </ValidationProvider>

                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                >
                  <v-expansion-panel-header>2. polugodište</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ValidationProvider
                        :name="item.name"
                        :rules="item.rules"
                        mode="eager"
                        ref="provider"
                        v-bind:key="item.name"
                        v-for="item in items2"
                    >
                      <div slot-scope="{ errors }">
                        <v-row no-gutters>

                          <!--Label for the form-->
                          <v-col cols="12" md="3" style="height: 44px" class="d-flex justify-end">
                            <div class="d-flex align-center justify-end text-right mb-2">
                                  <span class="font-weight-bold text--primary"
                                        :style="{color: errors.length > 0 ? 'rgb(236 29 36) !important' : '', opacity: 0.8, marginRight: '8px'}">{{ item.title }}:</span>
                            </div>
                          </v-col>
                          <!-- Text field -->
                          <v-col cols="12" md="9">

                            <v-text-field
                                dense
                                :name="item.name"
                                outlined
                                :type="item.type"
                                :placeholder="item.rules && item.rules.includes('required') ? 'Obavezno...' : ''"
                                :prepend-icon="item.icon"
                                v-if="item.tag === 'input'"
                                v-model="form[item.name]">
                            </v-text-field>

                            <v-autocomplete
                                outlined
                                dense
                                :placeholder="item.rules ? 'Obavezno..' : ''"
                                :items="item.source"
                                :name="item.name"
                                :prepend-icon="item.icon"
                                :item-text="item.text"
                                :item-value="item.value"
                                v-if="item.tag === 'select'&& item.name!='are_numerical_grades'"
                                v-model="form[item.name]">
                            </v-autocomplete>
                            <v-autocomplete
                                outlined
                                dense
                                :placeholder="item.rules ? 'Obavezno..' : ''"
                                :items="item.source"
                                :name="item.name"
                                :prepend-icon="item.icon"
                                :item-text="item.text"
                                :item-value="item.value"
                                v-if="item.tag === 'select' && item.name=='are_numerical_grades' "
                                @change="updateDepartment(true, false, true)"
                                v-model="form[item.name]">
                            </v-autocomplete>

                            <!-- Date picker -->
                            <v-menu
                                v-model="item.model"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                                v-if="item.tag === 'date'"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="form[item.name]"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="form[item.name]" >

                              </v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </div>
                    </ValidationProvider>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  v-if="department.graduation_type===1"
                >
                  <v-expansion-panel-header>Matura</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ValidationProvider
                        :name="item.name"
                        :rules="item.rules"
                        mode="eager"
                        ref="provider"
                        v-bind:key="item.name"
                        v-for="item in items3"
                    >
                      <div slot-scope="{ errors }">
                        <v-row no-gutters>

                          <!--Label for the form-->
                          <v-col cols="12" md="3" style="height: 44px" class="d-flex justify-end">
                            <div class="d-flex align-center justify-end text-right mb-2">
                                  <span class="font-weight-bold text--primary"
                                        :style="{color: errors.length > 0 ? 'rgb(236 29 36) !important' : '', opacity: 0.8, marginRight: '8px'}">{{ item.title }}:</span>
                            </div>
                          </v-col>
                          <!-- Text field -->
                          <v-col cols="12" md="9">

                            <v-text-field
                                dense
                                :name="item.name"
                                outlined
                                :type="item.type"
                                :placeholder="item.rules && item.rules.includes('required') ? 'Obavezno...' : ''"
                                :prepend-icon="item.icon"
                                v-if="item.tag === 'input'"
                                v-model="form[item.name]">
                            </v-text-field>

                            <v-autocomplete
                                outlined
                                dense
                                :placeholder="item.rules ? 'Obavezno..' : ''"
                                :items="item.source"
                                :name="item.name"
                                :prepend-icon="item.icon"
                                :item-text="item.text"
                                :item-value="item.value"
                                v-if="item.tag === 'select'"
                                v-model="form[item.name]">
                            </v-autocomplete>

                            <!-- Date picker -->
                            <v-menu
                                v-model="item.model"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                                v-if="item.tag === 'date'"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="form[item.name]"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="form[item.name]" >

                              </v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </div>
                    </ValidationProvider>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                    v-if="department.graduation_type===2"

                >
                  <v-expansion-panel-header>Završni rad</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ValidationProvider
                        :name="item.name"
                        :rules="item.rules"
                        mode="eager"
                        ref="provider"
                        v-bind:key="item.name"
                        v-for="item in items4"
                    >
                      <div slot-scope="{ errors }">
                        <v-row no-gutters>

                          <!--Label for the form-->
                          <v-col cols="12" md="3" style="height: 44px" class="d-flex justify-end">
                            <div class="d-flex align-center justify-end text-right mb-2">
                                  <span class="font-weight-bold text--primary"
                                        :style="{color: errors.length > 0 ? 'rgb(236 29 36) !important' : '', opacity: 0.8, marginRight: '8px'}">{{ item.title }}:</span>
                            </div>
                          </v-col>
                          <!-- Text field -->
                          <v-col cols="12" md="9">

                            <v-text-field
                                dense
                                :name="item.name"
                                outlined
                                :type="item.type"
                                :placeholder="item.rules && item.rules.includes('required') ? 'Obavezno...' : ''"
                                :prepend-icon="item.icon"
                                v-if="item.tag === 'input'"
                                v-model="form[item.name]">
                            </v-text-field>

                            <v-autocomplete
                                outlined
                                dense
                                :placeholder="item.rules ? 'Obavezno..' : ''"
                                :items="item.source"
                                :name="item.name"
                                :prepend-icon="item.icon"
                                :item-text="item.text"
                                :item-value="item.value"
                                v-if="item.tag === 'select'"
                                v-model="form[item.name]">
                            </v-autocomplete>

                            <!-- Date picker -->
                            <v-menu
                                v-model="item.model"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                                v-if="item.tag === 'date'"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="form[item.name]"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="form[item.name]" >

                              </v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </div>
                    </ValidationProvider>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                >
                  <v-expansion-panel-header>Svjedodžba prijevodnica 1. polugodište</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ValidationProvider
                        :name="item.name"
                        :rules="item.rules"
                        mode="eager"
                        ref="provider"
                        v-bind:key="item.name"
                        v-for="item in items5"
                    >
                      <div slot-scope="{ errors }">
                        <v-row no-gutters>

                          <!--Label for the form-->
                          <v-col cols="12" md="3" style="height: 44px" class="d-flex justify-end">
                            <div class="d-flex align-center justify-end text-right mb-2">
                                  <span class="font-weight-bold text--primary"
                                        :style="{color: errors.length > 0 ? 'rgb(236 29 36) !important' : '', opacity: 0.8, marginRight: '8px'}">{{ item.title }}:</span>
                            </div>
                          </v-col>
                          <v-col cols="12" md="9">
                            <v-autocomplete
                                outlined
                                dense
                                :placeholder="item.rules ? 'Obavezno..' : ''"
                                :items="item.source"
                                :name="item.name"
                                :prepend-icon="item.icon"
                                :item-text="item.text"
                                :item-value="item.value"
                                v-if="item.tag === 'select'"
                                v-model="form[item.name]">
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </div>
                    </ValidationProvider>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                >
                  <v-expansion-panel-header>Svjedodžba prijevodnica 2. polugodište</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <ValidationProvider
                        :name="item.name"
                        :rules="item.rules"
                        mode="eager"
                        ref="provider"
                        v-bind:key="item.name"
                        v-for="item in items6"
                    >
                      <div slot-scope="{ errors }">
                        <v-row no-gutters>

                          <!--Label for the form-->
                          <v-col cols="12" md="3" style="height: 44px" class="d-flex justify-end">
                            <div class="d-flex align-center justify-end text-right mb-2">
                                  <span class="font-weight-bold text--primary"
                                        :style="{color: errors.length > 0 ? 'rgb(236 29 36) !important' : '', opacity: 0.8, marginRight: '8px'}">{{ item.title }}:</span>
                            </div>
                          </v-col>
                          <v-col cols="12" md="9">
                            <v-autocomplete
                                outlined
                                dense
                                :placeholder="item.rules ? 'Obavezno..' : ''"
                                :items="item.source"
                                :name="item.name"
                                :prepend-icon="item.icon"
                                :item-text="item.text"
                                :item-value="item.value"
                                v-if="item.tag === 'select'"
                                v-model="form[item.name]">
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </div>
                    </ValidationProvider>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                  :name="item.name"
                  :rules="item.rules"
                  mode="eager"
                  ref="provider"
                  v-bind:key="item.name"
                  v-for="item in itemsAdditional"
              >
                <div slot-scope="{ errors }">
                  <v-row no-gutters>

                    <!--Label for the form-->
                    <v-col cols="12" md="3" style="height: 44px" class="d-flex justify-end">
                      <div class="d-flex align-center justify-end text-right mb-2">
                                  <span class="font-weight-bold text--primary"
                                        :style="{color: errors.length > 0 ? 'rgb(236 29 36) !important' : '', opacity: 0.8, marginRight: '8px'}">{{ item.title }}:</span>
                      </div>
                    </v-col>
                    <!-- Text field -->
                    <v-col cols="12" md="9">

                      <v-text-field
                          dense
                          :name="item.name"
                          outlined
                          :type="item.type"
                          :placeholder="item.rules && item.rules.includes('required') ? 'Obavezno...' : ''"
                          :prepend-icon="item.icon"
                          v-if="item.tag === 'input'"
                          v-model="form[item.name]">
                      </v-text-field>

                      <v-autocomplete
                          outlined
                          dense
                          :placeholder="item.rules ? 'Obavezno..' : ''"
                          :items="item.source"
                          :name="item.name"
                          :prepend-icon="item.icon"
                          :item-text="item.text"
                          :item-value="item.value"
                          v-if="item.tag === 'select'&& item.name!='are_numerical_grades'"
                          v-model="form[item.name]">
                      </v-autocomplete>
                      <v-autocomplete
                          outlined
                          dense
                          :placeholder="item.rules ? 'Obavezno..' : ''"
                          :items="item.source"
                          :name="item.name"
                          :prepend-icon="item.icon"
                          :item-text="item.text"
                          :item-value="item.value"
                          v-if="item.tag === 'select' && (item.name=='are_numerical_grades' || item.name=='are_numerical_grades_semester')"
                          @change="updateDepartment(true, false, true)"
                          v-model="form[item.name]">
                      </v-autocomplete>

                      <!-- Date picker -->
                      <v-menu
                          v-model="item.model"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                          v-if="item.tag === 'date'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              outlined
                              dense
                              v-model="form[item.name]"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="form[item.name]" >

                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </div>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-container>

        <v-divider></v-divider>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="closeEdit"
              class="text-none"
              depressed
              large
              outlined
            >
              Odustani
            </v-btn>
            <v-btn
              color="primary"
              class="text-none"
              depressed
              large
              @click="updateDepartment(false)"
            >
              Potvrdi
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {extend, setInteractionMode, ValidationProvider} from 'vee-validate';
import {digits, email, max, min, required} from 'vee-validate/dist/rules';

import ApiV2 from '@/services/ApiV2'
import {serverBus} from "@/main";

export default {
  components: {
    ValidationProvider
  },

  data () {
    return{
      dialog: false,
      form: {},
      department: {},
      departmentInfo: {},
      departmentInfo1: {},
      departmentInfo2: {},
      departmentInfo4: {},
      departmentInfo5: {},
      departmentId: null,
      cantonTemplates: {},
      items1: [
        {
            data: "semester_template_id",
            name: 'semester_template_id',
            options: '',
            rules: 'required',
            source: [],
            text: 'label',
            value: 'id',
            tag: 'select',
            type : 'text',
            title: 'Predložak'
        },
        {
            data: "docket_number_semester",
            name: 'docket_number_semester',
            options: '',
            rules: '',
            source: [],
            tag: 'input',
            type : 'text',
            title: 'Urudžbeni broj'
        },
        {
          data: "diploma_semester_date",
          name: 'diploma_semester_date',
          options: '',
          rules: 'required',
          tag: 'date',
          title: 'Datum ispisa',
          type: 'text',
          model: false
        },
        {
          data: "are_numerical_grades_semester",
          name: 'are_numerical_grades_semester',
          options: '',
          source: [{text: 'Brojčane', value: true}, {text: 'Opisne', value: false}],
          rules: 'required',
          tag: 'select',
          value: 'value',
          text: 'text',
          title: 'Vrsta ocjena',
          type: 'boolean',
        },
      ],
      items2: [
        {
          data: "diploma_template_id",
          name: 'diploma_template_id',
          options: '',
          rules: '',
          source: [],
          text: 'label',
          value: 'id',
          tag: 'select',
          type : 'text',
          title: 'Predložak'
        },
        {
          data: "docket_number",
          name: 'docket_number',
          options: '',
          rules: '',
          source: [],
          tag: 'input',
          type : 'text',
          title: 'Urudžbeni broj'
        },
        {
          data: "diploma_date",
          name: 'diploma_date',
          options: '',
          rules: 'required',
          tag: 'date',
          title: 'Datum ispisa',
          type: 'text',
          model: false
        },
        {
          data: "are_numerical_grades",
          name: 'are_numerical_grades',
          options: '',
          source: [{text: 'Brojčane', value: true}, {text: 'Opisne', value: false}],
          rules: 'required',
          tag: 'select',
          value: 'value',
          text: 'text',
          title: 'Vrsta ocjena',
          type: 'boolean',
        },
      ],
      items3: [
        {
          data: "graduation_template_id",
          name: 'graduation_template_id',
          options: '',
          rules: 'required',
          source: [],
          text: 'label',
          value: 'id',
          tag: 'select',
          type : 'text',
          title: 'Predložak (matura)'
        },
        {
          data: "graduation_released_template_id",
          name: 'graduation_released_template_id',
          options: '',
          rules: 'required',
          source: [],
          text: 'label',
          value: 'id',
          tag: 'select',
          type : 'text',
          title: 'Predložak (Oslobođen polaganja mature)'
        },
        {
          data: "docket_number_graduation",
          name: 'docket_number_graduation',
          options: '',
          rules: '',
          source: [],
          tag: 'input',
          type : 'text',
          title: 'Urudžbeni broj'
        },
        {
          data: "date_end",
          name: 'date_end',
          options: '',
          rules: 'required',
          tag: 'date',
          title: 'Datum završetka završnog razreda',
          type: 'text',
          model: false
        },
        {
          data: "graduation_date",
          name: 'graduation_date',
          options: '',
          rules: 'required',
          tag: 'date',
          title: 'Datum ispisa (matura)',
          type: 'text',
          model: false
        },
        {
          data: "graduation_released_date",
          name: 'graduation_released_date',
          options: '',
          rules: 'required',
          tag: 'date',
          title: 'Datum ispisa (oslobođen mature)',
          type: 'text',
          model: false
        },
      ],
      items4: [
        {
          data: "graduation_template_id",
          name: 'graduation_template_id',
          options: '',
          rules: 'required',
          source: [],
          text: 'label',
          value: 'id',
          tag: 'select',
          type : 'text',
          title: 'Predložak (završni rad)'
        },
        {
          data: "graduation_released_template_id",
          name: 'graduation_released_template_id',
          options: '',
          rules: 'required',
          source: [],
          text: 'label',
          value: 'id',
          tag: 'select',
          type : 'text',
          title: 'Predložak (Oslobođen polaganja završnog rada)'
        },
        {
          data: "docket_number_graduation",
          name: 'docket_number_graduation',
          options: '',
          rules: '',
          source: [],
          tag: 'input',
          type : 'text',
          title: 'Urudžbeni broj'
        },
        {
          data: "date_end",
          name: 'date_end',
          options: '',
          rules: 'required',
          tag: 'date',
          title: 'Datum završetka završnog razreda',
          type: 'text',
          model: false
        },
        {
          data: "graduation_date",
          name: 'graduation_date',
          options: '',
          rules: 'required',
          tag: 'date',
          title: 'Datum ispisa (završni rad)',
          type: 'text',
          model: false
        },
        {
          data: "graduation_released_date",
          name: 'graduation_released_date',
          options: '',
          rules: 'required',
          tag: 'date',
          title: 'Datum ispisa (oslobođen završnog rada)',
          type: 'text',
          model: false
        },
      ],
      items5: [
        {
          data: "change_of_school_semester_template_id",
          name: 'change_of_school_semester_template_id',
          options: '',
          rules: '',
          source: [],
          text: 'label',
          value: 'id',
          tag: 'select',
          type : 'text',
          title: 'Predložak (svjedožba prijevodnica 1. polugodište)'
        },
      ],
      items6: [
        {
          data: "change_of_school_template_id",
          name: 'change_of_school_template_id',
          options: '',
          rules: '',
          source: [],
          text: 'label',
          value: 'id',
          tag: 'select',
          type : 'text',
          title: 'Predložak (svjedožba prijevodnica 2. polugodište)'
        },
      ],
      itemsAdditional: [
        // {
        //   data: "docket_number",
        //   name: 'docket_number',
        //   options: '',
        //   rules: '',
        //   source: [],
        //   tag: 'input',
        //   type : 'text',
        //   title: 'Urudžbeni broj'
        // },
        // {
        //   data: "are_numerical_grades",
        //   name: 'are_numerical_grades',
        //   options: '',
        //   source: [{text: 'Brojčane', value: true}, {text: 'Opisne', value: false}],
        //   rules: 'required',
        //   tag: 'select',
        //   value: 'value',
        //   text: 'text',
        //   title: 'Vrsta ocjena',
        //   type: 'boolean',
        // },
      ]


    }
  },

  async created() {
        this.departmentId = this.$route.params.odjeljenje_id;

        setInteractionMode('eager');

        extend('min', min);
        extend('max', max);
        extend('digits', digits);
        extend('email', email);
        extend('required', {...required, message: 'Ovo polje je obavezno.'});

        await this.getDepartment();
        await this.getCantonTemplates();
  },


  computed: {
    currentSchool() {
      return this.$store.getters.getSchool;
    }
  },

  methods:{
    openEdit() {
      Object.assign(this.form, this.department);
      this.dialog = true;
    },

    closeEdit() {
      this.dialog = false;
      this.form = {};
    },

    async getDepartment() {
      let {data} = await ApiV2.get(`departments/${this.departmentId}`)
          this.department = data
      let data2 = await ApiV2.get(`departments/${this.departmentId}/selected_templates`)
      if(data2.data["1. polugodište"].length>0){
        this.department.semester_template = data2.data["1. polugodište"][0];
        this.department.semester_template_id = data2.data["1. polugodište"][0].id;
      }
      if(data2.data["2. polugodište"].length>0){
        this.department.diploma_template = data2.data["2. polugodište"][0]
        this.department.diploma_template_id =data2.data["2. polugodište"][0].id
      }
      if(data2.data["Matura"].length>0){
        this.department.graduation_template = data2.data["Matura"][0]
        this.department.graduation_template_id = data2.data["Matura"][0].id
      }
      if(data2.data["Oslobođen mature"].length>0){
        this.department.graduation_released_template = data2.data["Oslobođen mature"][0]
        this.department.graduation_released_template_id = data2.data["Oslobođen mature"][0].id
      }
      if(data2.data["Završni rad"].length>0){
        this.department.graduation_template = data2.data["Završni rad"][0]
        this.department.graduation_template_id = data2.data["Završni rad"][0].id
      }
      if(data2.data["Oslobođen završnog rada"].length>0){
        this.department.graduation_released_template = data2.data["Oslobođen završnog rada"][0]
        this.department.graduation_released_template_id = data2.data["Oslobođen završnog rada"][0].id
      }
      if(data2.data["Svjedodžba prijevodnica 1. polugodište"].length>0){
        this.department.change_of_school_semester_template = data2.data["Svjedodžba prijevodnica 1. polugodište"][0]
        this.department.change_of_school_semester_template_id =data2.data["Svjedodžba prijevodnica 1. polugodište"][0].id
      }
      if(data2.data["Svjedodžba prijevodnica 2. polugodište"].length>0){
        this.department.change_of_school_template = data2.data["Svjedodžba prijevodnica 2. polugodište"][0]
        this.department.change_of_school_template_id =data2.data["Svjedodžba prijevodnica 2. polugodište"][0].id
      }
          this.optimizeData(this.department);
    },

    async getCantonTemplates() {
      if(this.currentSchool) {
        let {data} = await ApiV2.get(`departments/${this.departmentId}/templates_frontend_data`);
        this.cantonTemplates = data;
          this.items1.forEach((item) => {
            if(item.name === 'semester_template_id') {
              item.source = this.cantonTemplates["1. polugodište"]
            }
          })
          this.items2.forEach((item) => {
            if(item.name === 'diploma_template_id') {
              item.source = this.cantonTemplates["2. polugodište"]
            }
          })
          this.items3.forEach((item) => {
            if(item.name ===  'graduation_template_id') {
              item.source = this.cantonTemplates["Matura"];
            }
            if(item.name ===  'graduation_released_template_id') {
              item.source = this.cantonTemplates["Oslobođen mature"];
            }
          })
          this.items4.forEach((item) => {
            if(item.name ===  'graduation_template_id') {
              item.source = this.cantonTemplates["Završni rad"];
            }
            if(item.name ===  'graduation_released_template_id') {
              item.source = this.cantonTemplates["Oslobođen završnog rada"];
            }
          })
        this.items5.forEach((item) => {
          if(item.name === 'change_of_school_semester_template_id') {
            item.source = this.cantonTemplates["Svjedodžba prijevodnica 1. polugodište"]
          }
        })
        this.items6.forEach((item) => {
          if(item.name === 'change_of_school_template_id') {
            item.source = this.cantonTemplates["Svjedodžba prijevodnica 2. polugodište"]
          }
        })
      }
    },

    async updateDepartment(fromSelect=false, semester=false, end=false) {
      if(fromSelect){
        if(semester){
          this.form['semester_template_id']=null
        }
        if(end){
          this.form['diploma_template_id']=null
        }
      }
      let keys = ['semester_template_id', 'graduation_template_id', 'diploma_template_id','graduation_released_template_id','change_of_school_semester_template_id','change_of_school_template_id'];
      let templates = [];
      keys.forEach(k=>{
        if (this.form[k]){
          templates.push(this.form[k])
        }
      })
      let {data} = await ApiV2.post(`departments/${this.departmentId}/documentTemplates`, {data: templates, method: 'sync'})
      await ApiV2.put(`departments/${this.departmentId}`, this.form)
      if (data){
        if(!fromSelect){
          this.closeEdit();
        }
        await this.getDepartment();
        await this.getCantonTemplates();
        serverBus.$emit('show-snackbar',  true);
      }else{
        serverBus.$emit('show-snackbar',  false);
      }
    },

    optimizeData(data) {
      console.log(this.departmentInfo , 1234124324324)
      this.departmentInfo = {
        'Predložak (polugodište)': data.semester_template?.label,
        'Predložak (svjedodžba)': data.diploma_template?.label,
        'Datum ispisa (polugodište)': this.$parseDate(data.diploma_semester_date),
        'Datum ispisa (svjedodžba)': this.$parseDate(data.diploma_date),
        'Vrsta ocjena (polugodište)': (data.are_numerical_grades_semester) ? 'Brojčane' : 'Opisne',
        'Vrsta ocjena (kraj)': (data.are_numerical_grades) ? 'Brojčane' : 'Opisne'
      }
          this.departmentInfo1 = {
            'Predložak (matura)': data.graduation_template?.label,
            'Predložak (oslobodjen mature)': data.graduation_released_template?.label,
            'Datum ispisa (matura)': this.$parseDate(data.graduation_date),
            'Datum ispisa (oslobođen mature)': this.$parseDate(data.graduation_released_date),
          }
      this.departmentInfo2 = {
        'Predložak (završni rad)': data.graduation_template?.label,
        'Predložak (oslobodjen završnog rada)': data.graduation_released_template?.label,
        'Datum ispisa (završni rad)': this.$parseDate(data.graduation_date),
        'Datum ispisa (oslobodjen završnog rada)': this.$parseDate(data.graduation_released_date),
      }
      this.departmentInfo4 = {
        'Predložak (prijevodnica 1. polugodište)': data.change_of_school_semester_template?.label,
      }
      this.departmentInfo5 = {
        'Predložak (prijevodnica 2. polugodište)': data.change_of_school_template?.label,
      }
    }
  }
}
</script>

<style>
  .v-date-picker-table {
    height: unset !important;
  }
</style>